import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { AUTOCOMPLETE_MAX_ITEMS } from '../../utils/constants';
import { CancelToken } from 'axios';
import { SupplierEmployeeDto } from '@api/models/suppliers/SupplierEmployeeDto';
import { supplierEmployeeService } from '@api/services/services';

type State = BaseType<SupplierEmployeeDto[]>;

const initialState: State = {
  state: FetchState.None,
  data: [],
};

export const optionsCompanySupplierEmployeesSlice = baseSlice({
  name: 'optionsCompanySupplierEmployees',
  initialState,
});

export const selectOptionsCompanySupplierEmployeesState = (state: RootState) =>
  state.optionsCompanySupplierEmployees.state;
export const selectOptionsCompanySupplierEmployees = (state: RootState) =>
  state.optionsCompanySupplierEmployees.data;
export const optionsCompanySupplierEmployeesActions = optionsCompanySupplierEmployeesSlice.actions;

export const getOptionsCompanySupplierEmployees =
  (companyId: string | undefined, supplierIds: string[], search: string | undefined, cancelToken: CancelToken) =>
  (dispatch: AppDispatch) => {
    if (!companyId) {
      return;
    }

    const handleGetData = async () => {
      const response = await supplierEmployeeService.querySupplierEmployeesByCompany(
        {
          companyId,
          suppliers: supplierIds.length ? supplierIds : undefined,
          q: search,
          page: 0,
          size: AUTOCOMPLETE_MAX_ITEMS,
          sort: ['name', 'asc'],
        },
        { cancelToken }
      );
      return { data: response.data.content ?? [] };
    };

    getItem({
      dispatch,
      actions: optionsCompanySupplierEmployeesActions,
      getData: handleGetData,
    });
  };
